import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { LoginComponent } from './login/login.component';
import { ForbiddenComponent } from "./forbidden/forbidden.component";


const routes: Routes = [
  {
    path: 'manager',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren:
          './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
      }
    ]
  },
  {
    path: '',
    loadChildren:
      './login/login.module#LoginModule'
  },
  {
    path: 'forbidden',
    children: [
      {
        path: '',
        loadChildren:
          './forbidden/forbidden.module#ForbiddenModule'
      }
    ]
    
  }

];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
